import { Input, Button } from "@/components/ui";
import { Search } from "lucide-react";
import usePositionConfig from "./usePositionConfig";
import { DataTable, Dialog, Loader } from "@/components";
import { AddEditPosition } from "./AddEditPosition";

const PositionConfig = () => {
  const {
    globalFilter,
    setGlobalFilter,
    onAddPosition,
    columns,
    positionList,
    isLoadingPositionList,
    isAddEditPosition,
    selectedPosition,
    isViewPosition,
    onCancelAddEditPosition,
    openDeleteDialog,
    setOpenDeleteDialog,
    onDeleteConfirm,
    isDeletePositionPending,
    deletedRow,
    onRowClick,
  } = usePositionConfig();

  return isAddEditPosition || isViewPosition ? (
    <AddEditPosition
      selectedPosition={selectedPosition}
      isViewPosition={isViewPosition}
      onCancel={onCancelAddEditPosition}
    />
  ) : (
    <div className="flex flex-col gap-5 mt-4">
      <div className="flex flex-row items-end justify-end gap-4">
        <Input
          type="text"
          placeholder="Search"
          value={globalFilter ?? ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
          className="w-full sm:w-72 bg-white h-[40px]"
          startIcon={<Search className="w-4 h-4" />}
        />
        <Button onClick={onAddPosition}>+ Add Position</Button>
      </div>
      {isLoadingPositionList ? (
        <Loader />
      ) : (
        <DataTable
          columns={columns}
          data={(positionList?.data || []).slice().sort((a: any, b: any) => {
            return (b.active === true ? 1 : 0) - (a.active === true ? 1 : 0);
          })}
          setGlobalFilter={setGlobalFilter}
          globalFilter={globalFilter}
          onRowClick={onRowClick}
        />
      )}
      <Dialog
        open={openDeleteDialog}
        setOpen={setOpenDeleteDialog}
        title={
          <div className="text-2xl font-bold text-primary">
            {"Confirmation"}
            <div className="h-1 w-[30%] bg-primary rounded-full" />
          </div>
        }
        saveText="Delete"
        saveBtnClassName="bg-red-500 text-white hover:bg-red-500 hover:text-white"
        isLoading={isDeletePositionPending}
        onSave={onDeleteConfirm}
      >
        <p className="text-sm">
          Are you sure you want to delete this BM Position -{" "}
          <b className="text-primary">{deletedRow?.positionName || ""}</b>?
        </p>
      </Dialog>
    </div>
  );
};

export default PositionConfig;
